import { createApiClient, createApiTestkit } from '@wix/premium-fed-sdk/@apis-infra-react';
import { createQueriesConfig } from '@wix/premium-fed-sdk/apis-infra';
const API = '/_api/premium-package-pickers-api';
const getPersonalizedTitleQueryFn = async _ref => {
  let {
    httpClient,
    request
  } = _ref;
  const response = await httpClient.post(`${API}/get-personalized-title`, request);
  return response.data;
};
export const PersonalizedTitleQueriesConfig = createQueriesConfig({
  getPersonalizedTitle: {
    queryFn: getPersonalizedTitleQueryFn
  }
});
export const PersonalizedTitleApiClient = createApiClient(PersonalizedTitleQueriesConfig);
export const PersonalizedTitleApiClientTestkit = createApiTestkit(PersonalizedTitleQueriesConfig);
//# sourceMappingURL=personalized-title.api-client.js.map